export default {
  getFlags: state => state.flags,
  getFlag: state => state.flag,
  getFlagTypes: state => state.flagTypes,
  getSelectedFlagType: state => state.filters.params.flagTypeId,
  getPagination: state => state.pagination,
  getPageLength: state => state.filters.params.take,
  getCurrentPage: state => state.filters.params.page,
}
